// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card{border:none !important;background-color:#fff !important}.card-header{background-color:#fff !important;padding-top:0rem !important;padding-bottom:0rem !important}.card-header:last-child{border-bottom:0px !important}.accordion-question-toggle{display:flex;cursor:pointer}", ""]);
// Exports
module.exports = exports;
